import React from 'react';
import GenericSvgIcon from "@Icons/GenericSvgIcon";
import IconType from "@/types/Icon.type";

function IconHourglass(props: IconType) {
    const {
        width = '16',
        height = '16',
        fill = '#b5b7d1',
        outline = '#070c63',
        viewBox = '0 0 16 16',
        title = 'IconStationList',
        ...rest
    } = props

    return (
        <GenericSvgIcon
            width={width}
            height={height}
            fill={fill}
            outline={outline}
            viewBox={viewBox}
            title={title}
            {...rest}
            svgIconPath={(
                <g fill="none" fillRule="evenodd" transform="translate(3 1)">
                    <path
                        d="m0 .280085h10"
                        stroke={outline}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth=".980297"
                    />
                    <path
                        d="m5 9.58754391c-1.22556818 0-2.22221591.98953959-2.22221591 2.20622809v2.206228h4.44443182v-2.206228c0-1.2166885-.99664773-2.20622809-2.22221591-2.20622809z"
                        fill={fill}
                        fillRule="nonzero"
                    />
                    <g stroke={outline} strokeWidth=".980297">
                        <path d="m0 13.517358h10" strokeLinecap="round" strokeLinejoin="round"/>
                        <path
                            d="m1.11111364.28008481v2.75777105c0 2.13230246 1.74110227 3.86087388 3.88888636 3.86087388s3.88886364-1.72857142 3.88886364-3.86087388v-2.75777105"
                            strokeLinecap="square"
                        />
                        <path
                            d="m1.11111364 13.5173579v-2.7577711c0-2.13228565 1.74110227-3.86085706 3.88888636-3.86085706s3.88886364 1.72857141 3.88886364 3.86085706v2.7577711"
                            strokeLinecap="square"
                        />
                    </g>
                    <path
                        d="m2.77778409 2.48626804c0 1.21675003.99664773 2.20623365 2.22221591 2.20623365s2.22221591-.98948362 2.22221591-2.20623365z"
                        fill={fill}
                        fillRule="nonzero"
                    />
                </g>
            )}
        />

    );
}

export default IconHourglass;